<template>
  <div>
    <div id="section-to-print">
      <v-row type="flex" class="row-bg fTitle" style="padding-right: 20px;">
        <v-spacer></v-spacer>
        {{ transfer_status ? " ទម្រង់ទទួលស្តុក" :"ទម្រង់ផ្ទេរស្តុក" }}
      </v-row>
      <hr style="border-top: 3px solid green;">
      <table>
        <tr>
          <td colspan="6">
            {{ transfer_status ? ("ឈ្មោះអ្នកផ្ទេរ៖") : ("ឈ្មោះអ្នកទទួលផ្ទេរ៖") }} {{ datas.client }}
          </td>
          <td colspan="3">
            លេខទូរស័ព្ទ៖ {{ datas.phone | formatPhoneNumber }}
          </td>
        </tr>
        <tr>
          <td>អាស័យដ្ឋាន៖</td>
          <td colspan="8">{{ datas.address }}</td>
        </tr>
        <tr>
          <td>
            {{ transfer_status ? "ប្រភេទអ្នកផ្ទេរ៖" : "ប្រភេទអ្នកទទួលផ្ទេរ៖" }}
          </td>

          <td colspan="2">{{ datas.client_type }}</td>
         
          <td colspan="2">កាលបរិច្ឆេទ៖ {{ parseFromDate(datas.date) }}</td>
        </tr>
        <tr>
          <td colspan="7"></td>
          <td colspan="2">លេខទម្រង់ផ្ទេរស្តុក៖ {{ datas.reference }}</td>
        </tr>
      </table>

      <table class="border">
        <thead>
        <tr>
          <th>ល.រ</th>
          <th>ឈ្មោះទំនិញ</th>
          <th>ឯកតា</th>
          <th>បរិមាណ</th>
          <th>តម្លៃរាយ</th>
          <th>តម្លៃសរុប</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(tra, index) in datas.transaction_line" :key="index">
          <td style="text-align: center">{{ index + 1 }}</td>
          <td>{{ tra.product_name }}</td>
          <td style="text-align: center">{{ tra.unit_name }}</td>
          <td style="text-align: center">{{ +tra.transfer_qty }}</td>
          <td style="text-align: right">{{ +tra.price | formatNumber }}{{ getCurrencySymbol(datas.currency_code) }}</td>
          <td style="text-align: right">{{ +tra.price * +tra.transfer_qty | formatNumber}}{{ getCurrencySymbol(datas.currency_code) }}</td>
        </tr>

        <tr>
          <th colspan="4" style="text-align: right">សរុប</th>
          <td colspan="2" style="text-align: right; font-weight: bold">{{ +datas.total_amount | formatNumber }}{{ getCurrencySymbol(datas.currency_code) }}</td>
        </tr>
        </tbody>
      </table>
      <table style="margin-top: 15px;">
        <tr>
          <td>ពិនិត្យដោយ</td>
           <td style="text-align: center">
            ស្នាមមេដៃ{{ transfer_status ? "អ្នកផ្ទេរ៖" : "អ្នកទទួលផ្ទេរ៖" }}
          </td>
          
        </tr>
        <tr>
          <td style="padding-top: 50px;">កាលបរិច្ឆេទ ៖ ...............................</td>
        </tr>


      </table>
      <div class="footer-right">
        <p>Instant DN Form-V0 {{ today }}</p>
      </div>
    </div>


  </div>

</template>

<script>

import MainMixin from "../../../mixins/mainMixin"
import OptionDataMixin from "../../../mixins/optionDataMixin";
import moment from "moment";

export default {
  mixins: [MainMixin, OptionDataMixin],

  data() {
    return {
      transaction_id: '',
      transfer_status: '',
      today         :moment().format("YYYYMMDD"),
      datas: {
        client          : '',
        phone           : '',
        address         : '',
        client_type     : this.$t(this.$store.state.userDoc.type),
        date            : '',
        reference       : '',
        currency_code   : '',
        total_amount    : '',
        transaction_line: [],
      }
    }
  },
  methods: {
    handlePrint(event) {
      event.preventDefault();
      window.print();
    },

    async handleRun() {
      if(this.transaction_id){
        let vm = this;
        await this.fetchStockTransfer({
          transfer_status: vm.transfer_status,
          search: "",
          id: vm.transaction_id,
          offset: 0,
          sort_by: "created_at",
          sort_desc: 1,
          limit: 1,
        });

        if(vm.stockTransferList.length){

          let data = vm.stockTransferList[0];
          vm.datas.client            = this.transfer_status ? data.from_contact_name : data.to_contact_name;
          vm.datas.phone             = this.transfer_status ? data.from_contact_phone : data.to_contact_phone;
          vm.datas.address           = this.transfer_status ? data.from_contact_full_location: data.to_contact_full_location;
          vm.datas.date	             = data.date;
          vm.datas.reference	       = data.reference;
          vm.datas.currency_code	   = data.currency_code;
          vm.datas.total_amount      = data.total_amount;
          vm.datas.transaction_line  = data.transaction_transfer_line;

          vm.$nextTick(() => { window.print(); });
          vm.$nextTick(() => { this.$router.back(); });

        }
      }
    }
  },
  mounted(){
    this.handleRun();
  },
  created() { 
    this.transfer_status      = this.$route.params.transfer_status;
    this.transaction_id = this.$route.params.id;
  }
}
</script>